import { Body1, Button, Popover, PopoverSurface, PopoverTrigger } from '@fluentui/react-components';
import { InfoRegular } from '@fluentui/react-icons';
import { useState } from 'react';
import { useStyles } from './styles.js';

export type HintProps = {
    text: string;
};

export function Hint({ text }: HintProps) {
    const styles = useStyles();
    const [open, setOpen] = useState(false);

    return (
        <Popover open={open} onOpenChange={(_, data) => setOpen(data.open)}>
            <PopoverTrigger disableButtonEnhancement>
                <Button
                    appearance="transparent"
                    icon={<InfoRegular />}
                    size="medium"
                    className={styles.hintButton}
                    aria-label="Hinweis"
                />
            </PopoverTrigger>
            <PopoverSurface className={styles.popoverSurface}>
                <Body1>{text}</Body1>
            </PopoverSurface>
        </Popover>
    );
}
